import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { useEffect, useState } from "react";
import Loader from "../../../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../../../helper/notification-messages";
import { clinicService } from "../../../../services/clinicService";
import { useLocation } from "react-router";
import { Tooltip } from "@progress/kendo-react-tooltip";
import DeleteDialogModal from "../../../../control-components/custom-delete-dialog-box/delete-dialog";
import { useNavigate } from "react-router";
import { NotificationManager } from "src/util/notify";
import AddClinicContact from "./add-clinic-contact";
import { MaskFormatted } from "../../../../helper/mask-helper";
import moment from "moment";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function ClinicContactInfo() {
  const { state } = useLocation();
  const regionData = state?.field?.regionId;
  const masterClinicId = state?.field?.masterClinicId;
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(7);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [loading, setLoading] = useState(false);
  const [clinicContact, setClinicContact] = useState([]);
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [isAdd, setIsAdd] = useState(false);
  const [itemState, setItemState] = useState("");
  const [canAddContact, setCanAddContact] = useState(true);

  useEffect(() => {
    getClinicContactInfo();
  }, []);

  useEffect(() => {
    setPage(0);
  }, [clinicContact]);

  const getClinicContactInfo = async () => {
    setLoading(true);
    await clinicService
      .getClinicContactInfo(regionData, masterClinicId)
      .then((result) => {
        if (result.resultData.length >= 0) {
          setClinicContact(result.resultData);
          if (result.resultData.length >= 2) {
            setCanAddContact(false);
          } else {
            setCanAddContact(true);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };

  const DeleteClinicContact = async () => {
    setLoading(true);
    await clinicService
      .DeleteClinicContact(selectedId, regionData)
      .then((result) => {
        NotificationManager.success("Contact deleted successfully.");
        setLoading(false);
        setDeleteConfirm(!isDeleteConfirm);
        getClinicContactInfo();
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };

  const handleClose = () => {
    setDeleteConfirm(!isDeleteConfirm);
  };

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };
  const deleteSelectId = (id) => {
    setDeleteConfirm(true);
    setSelectedId(id);
  };


  const handleEditClinicContact = (field) => {
    setIsAdd(true);
    setItemState(field);
  };

  const handleAddClinicContact = () => {
    setIsAdd(true);
  };

  const handleCloseContact = ({ updated }) => {
    if (updated) {
      getClinicContactInfo();
    }
    setIsAdd(false);
    setItemState("");
  };



  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 className="address-title text-grey ">
          <span className="f-24">Clinic Contact</span>
        </h4>
        {canAddContact && <button class="green-btn btn-primary" onClick={handleAddClinicContact}>
          <span
            class="k-icon k-font-icon k-i-plus"
            style={{ color: "#fff" }}
          ></span>{" "}
          Add Contact
        </button>}

      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2"></div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading === true ? <Loader /> :

                  <Grid
                    data={orderBy(
                      clinicContact.slice(page, pageSize + page),
                      sort
                    ).map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    checkboxElement
                    style={{
                      height: clinicContact.length > 0 ? "100%" : "250px",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    skip={page}
                    take={pageSize}
                    total={clinicContact.length}
                    onPageChange={pageChange}
                    pageable={{}}
                    sort={sort}
                    sortable={true}
                    onSortChange={(e) => {
                      setSort(e.sort);
                    }}
                  >
                    <GridColumn
                      width={150}
                      className="cursor-default"
                      field="name"
                      title="Name"
                    />
                    <GridColumn
                      width={150}
                      className="cursor-default"
                      title="Phone"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.phone;
                          return <td>{MaskFormatted(field, "(999) 999-9999")}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      width={220}
                      className="cursor-default"
                      field="email"
                      title="Email"
                    />
                    <GridColumn
                      width={100}
                      className="cursor-default"
                      title="Date"
                      cells={{
                        data: (props) => {
                          return <td>{props?.dataItem?.utcDateCreated != null ? moment(props?.dataItem?.utcDateCreated).format("MM/DD/YYYY") : "N/A"}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      width={150}
                      className="cursor-default"
                      field="isPrimary"
                      title="Primary Contact"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isPrimary;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : (
                                <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                              )}
                            </td>
                          );
                        }
                      }}
                    />

                    <GridColumn
                      width={120}
                      title="Action"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;
                          return (
                            <td>
                              <div className="row-3">
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                  onClick={() => deleteSelectId(field.id)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                        title="Delete"
                                      ></i>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                  onClick={() => handleEditClinicContact(field)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i className="fas fa-edit" title="Edit"></i>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAdd && (
        <AddClinicContact
          onClose={handleCloseContact}
          regionId={regionData}
          masterClinicId={masterClinicId}
          state={itemState}
        />
      )}
      {isDeleteConfirm && (
        <DeleteDialogModal
          onClose={handleClose}
          title="Clinic Contact"
          message="Clinic Contact"
          handleDelete={DeleteClinicContact}
        />
      )}
    </>
  );
}
export default ClinicContactInfo;
